import { type ReactNode } from 'react'

import type { TicketPriority, TicketStatus } from '@aeris/communication'
import { Badge } from '@aeris/ui'

import { PRIORITY_META, STATUS_META } from '../lib/ticket-meta.tsx'

/** Os dois selos de um chamado (F051) — os rótulos e as cores vêm de `lib/ticket-meta.tsx`. */

export const StatusBadge = ({
  status,
}: {
  status: TicketStatus
}): ReactNode => {
  const meta = STATUS_META[status]
  return (
    <Badge tone={meta.tone} icon={meta.icon}>
      {meta.label}
    </Badge>
  )
}

export const PriorityBadge = ({
  priority,
}: {
  priority: TicketPriority
}): ReactNode => {
  const meta = PRIORITY_META[priority]
  return (
    <Badge tone={meta.tone} icon={meta.icon}>
      {meta.label}
    </Badge>
  )
}
